import { FieldValues, Resolver } from 'react-hook-form';
import { Schema } from 'joi';
import { joiResolver } from '@hookform/resolvers/joi/dist/joi';
import { loadTranslations } from '@loyalty/shared-common';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const ns = ['joi', 'joi-loyalty'];

export function useJoiResolver<T extends FieldValues>(schema: Schema<T>): Resolver<T> {
  const { i18n } = useTranslation(ns);

  return useMemo(() => {
    const messages = loadTranslations(i18n, ns);

    return joiResolver(schema, {
      presence: 'required',
      allowUnknown: true,
      abortEarly: false,
      convert: true,
      errors: {
        language: i18n.language,
      },
      messages,
    });
  }, [schema, i18n, i18n.language]);
}
